<template>
  <div id="invoice">
      <div class="invoice_box">
        <div class="form_box">
          <el-form
            class="ser_form"
            ref="detailForm"
            label-position="right"
            label-width="130px"
            :hide-required-asterisk="true"
            :model="detailForm"
            :rules="rules"
          >
            <el-form-item class="s_form_t" label="发票抬头" prop="fpTaitou">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpTaitou"
                placeholder="请输入发票抬头"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="企业税号" prop="fpQysh">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpQysh"
                placeholder="请输入企业税号"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="企业注册地" prop="fpQyzcd">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpQyzcd"
                placeholder="请输入企业注册地"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="企业开户行名称" prop="fpKhhmc">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpKhhmc"
                placeholder="请输入企业开户行名称"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="银行账号" prop="fpBank">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpBank"
                placeholder="请输入银行账号"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="税务局留存电话" prop="fpSwjpho">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpSwjpho"
                placeholder="请输入税务局留存电话"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="接收邮箱" prop="fpEmail">
              <el-input
                class="inlineInput"
                v-model="detailForm.fpEmail"
                placeholder="请输入接收邮箱"
              ></el-input>
            </el-form-item>
           
          </el-form>
        </div>


        <div class="certbtn_box">
          <el-button class="certbtn" type="primary" @click="submitFormlogin('detailForm')">提交</el-button>
        </div>
      </div>
    
  </div>
</template>

<script>
import Qs from "qs";
import  {sesStorage}  from '@/model/storage.js'
export default {
  data() {
    return {
      detailForm: {},
      rules: {
        fpTaitou: [
          { required: true, message: "请输入发票抬头", trigger: "blur" },
        ],
        fpQysh: [
          { required: true, message: "请输入企业税号", trigger: "blur" },
        ],
        fpQyzcd: [
          { required: true, message: "请输入企业注册地", trigger: "blur" },
        ],
        fpBank: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        fpEmail: [
          { required: true, message: "请输入接收邮箱", trigger: "blur" },
        ],
        fpQysh: [
          { required: true, message: "请输入企业税号", trigger: "blur" },
        ],
        fpKhhmc: [
          { required: true, message: "请输入企业开户行名称", trigger: "blur" },
        ],
        fpSwjpho: [
          { required: true, message: "请输入税务局留存电话", trigger: "blur" },
        ],
      },
    };
  },
  components: {},
  methods: {
     getperson(){
        let param={
           token: sesStorage.get('userObj').token,
        }
        this.$http
          .post("/front/user/person", Qs.stringify(param))
          .then((res) => {
            if (res.data.code == 0) {
              this.detailForm=res.data.data
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
              if(res.data.code == 201){
                setTimeout(()=>{
                  this.$router.push({path:'/home/login'})
                },1000)
              }
            }
          })
      },
      submitFormlogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.detailForm.token=sesStorage.get('userObj').token;
                this.$http
                  .post("/front/user/personEdit", Qs.stringify(this.detailForm))
                  .then((res) => {
                    if (res.data.code == 0) {
                      this.$message({
                        message: res.data.msg,
                        type: "success",
                        center: true,
                      });
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                        center: true,
                      });
                      if(res.data.code == 201){
                        setTimeout(()=>{
                          this.$router.push({path:'/home/login'})
                        },1000)
                      }
                    }
                  })
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getperson()
  },
  watch: {},
};
</script>


<style lang="scss" scoped>
#invoice {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img {
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
 

  .ser_form {
    & >>> .el-form-item__label {
      font-size: 16px;
      font-weight: bold;
      color: #303643;
    }
    & >>> .el-input__inner::placeholder {
      color: #999;
    }
  }
  .pagetit {
    text-align: center;
    margin-top: 56px;
    margin-bottom: 44px;
  }
  .form_box {
    margin: 0 auto;
  }
  .s_form_t {
    display: inline-block;
    margin-right: 85px;
    & >>> .el-form-item__label {
      font-size: 14px;
    }
  }
  .inlineInput {
    & >>> .el-input__inner {
      width: 400px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
    & >>> .el-select__caret {
      color: #303643;
    }
    & >>> .el-date-editor.el-input,
    & >>> .el-date-editor.el-input__inner {
      width: 400px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
  }

  .invoice_box {
    margin-top: 40px;
  }

  .certbtn_box {
    width: 120px;
    margin: 42px auto 10px auto;
  }
  .certbtn {
    height: 42px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
  }
  
}
</style>





// WEBPACK FOOTER //
// src/components/invoice.vue